import React from 'react';
import { jwtDecode } from 'jwt-decode';

import AMProcedures from '../Components/TablesForProceduresPage/AMProcedures';
import WorkerProcedures from '../Components/TablesForProceduresPage/WorkerProcedures';

import Loading from '../Components/Loading';
import HeadlinePanel from '../Components/HeadlinePanel';

export default function Procedures() {
  const [userId, setUserId] = React.useState('');
  const [userRole, setUserRole] = React.useState('');

  React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      const decodedToken = jwtDecode(token);
      setUserId(decodedToken.id);
      setUserRole(decodedToken.role);
    }
  }, []);


  if (!userId || !userRole) {
    return <Loading />;
  }

  return (
    <>
      <div className='mainContainer'>
        <HeadlinePanel label= 'Процедуры' type='' />
        <div className='containerInner'>
          {userRole === 'Арбитражный управляющий' ? (
            <AMProcedures userId={userId} isFromAccount={false} />
          ) : (
            <WorkerProcedures />
          )}
        </div>
      </div>
    </>
  );
};
